<div class="modal-header" id="material-order-modal-title">
    <h3 class="modal-title" id="modal-title" translate="MATERIAL_ORDER_CREATE_TITLE"></h3>
    <span class="close" (click)="!isLoading && saveMaterialOrderData()">&times;</span>
</div>
<div class="modal-body">
    <form [formGroup]="materialOrderForm">
        <fieldset [disabled]="isLoading">
            <div class="row mb-3">
                <label
                    class="col-12 col-md-3 col-lg-2 col-form-label text-start text-lg-end"
                    for="priority"
                    translate="MATERIAL_ORDER_CREATE_PRIORITY_LABEL"
                ></label>
                <div class="col-12 col-md-9 col-lg-10 justify-content-start">
                    <pace-core-dropdown
                        class="col-12 col-lg-5"
                        id="priority"
                        name="priority"
                        [parentForm]="materialOrderFormChildren"
                        [(model)]="model.priority"
                        (valueChange)="onPriorityChange()"
                    ></pace-core-dropdown>
                </div>
            </div>
            <div class="row mb-3">
                <label
                    class="col-12 col-md-3 col-lg-2 col-form-label text-start text-lg-end mb-3"
                    for="materialDeliveryOption"
                    translate="MATERIAL_PICKUP_DELIVERY_ADDRESS_LABEL"
                ></label>
                <div class="col-12 col-md-9 col-lg-5 justify-content-start mb-3">
                    <pace-core-radio-input
                        id="materialDeliveryOption"
                        name="materialDeliveryOption"
                        [parentForm]="materialOrderFormChildren"
                        [(model)]="model.deliveryOptions"
                        (valueChange)="model.updateAddress(); updateDisplayAddressDetails()"
                    ></pace-core-radio-input>
                </div>
                <div class="col-12 col-md-9 offset-md-3 offset-lg-0 col-lg-5 justify-content-start mb-3">
                    <pace-core-dropdown
                        *ngIf="model.deliveryOptions.selectedEntry.model.name === model.DOP_ADDRESS"
                        id="dopNr"
                        [parentForm]="materialOrderFormChildren"
                        name="dopNr"
                        [(model)]="model.dopList"
                        (valueChange)="validateForm()"
                        [attr.aria-label]="model.dopList"
                    >
                    </pace-core-dropdown>
                </div>
            </div>
            <div class="row mb-3" *ngIf="displayAddressDetails">
                <div class="col-12" id="divAddressDetails" [ngClass]="{ 'dop-read-only': isTextInfoReadonly }">
                    <div class="mb-3 row">
                        <div *ngIf="this.model.isCustomerAddress" class="col-12 col-lg-6 offset-6">
                            <label class="col-form-label d-none d-lg-block text-start">
                                {{ this.model.subAddressMaxCharLabel }}
                            </label>
                        </div>
                        <div class="col-12 col-lg-6 mb-3 mb-lg-0">
                            <div [ngClass]="{ 'dop-read-only': model.isDopAddress }">
                                <div class="box-outlined" [ngClass]="{ border: this.model.isCustomerAddress }">
                                    <div class="mb-3 row">
                                        <label
                                            class="col-3 col-form-label"
                                            for="txtName1"
                                            translate="MATERIAL_ORDER_NAME_LABEL"
                                        ></label>
                                        <div class="col-9">
                                            <pace-core-text-input
                                                id="txtName1"
                                                [parentForm]="materialOrderFormChildren"
                                                name="txtName1"
                                                [(model)]="model.address.name1"
                                                [ariaLabel]="'MATERIAL_ORDER_NAME_LABEL' | translate"
                                            ></pace-core-text-input>
                                        </div>
                                    </div>
                                    <div class="mb-3 row">
                                        <div class="col-9 offset-3">
                                            <pace-core-text-input
                                                id="txtName2"
                                                [parentForm]="materialOrderFormChildren"
                                                name="txtName2"
                                                [(model)]="model.address.name2"
                                                [ariaLabel]="'MATERIAL_ORDER_ADDRESS_NAME_ARIA_LABEL' | translate"
                                            ></pace-core-text-input>
                                        </div>
                                    </div>
                                    <div class="mb-3 row">
                                        <label
                                            class="col-3 col-form-label"
                                            for="txtStreet"
                                            translate="MATERIAL_ORDER_STREET_LABEL"
                                        ></label>
                                        <div class="col-9">
                                            <pace-core-text-input
                                                id="txtStreet"
                                                [parentForm]="materialOrderFormChildren"
                                                name="txtStreet"
                                                [(model)]="model.address.street"
                                                [ariaLabel]="'MATERIAL_ORDER_STREET_LABEL' | translate"
                                            ></pace-core-text-input>
                                        </div>
                                    </div>
                                    <div class="mb-3 row">
                                        <ng-container *ngIf="displayBuilding">
                                            <label
                                                class="col-3 col-form-label"
                                                for="txtBuilding"
                                                translate="MATERIAL_ORDER_BUILDING_LABEL"
                                            ></label>
                                            <div class="col-9">
                                                <pace-core-text-input
                                                    id="txtBuilding"
                                                    [parentForm]="materialOrderFormChildren"
                                                    name="txtBuilding"
                                                    [(model)]="model.address.building"
                                                    [ariaLabel]="'MATERIAL_ORDER_BUILDING_LABEL' | translate"
                                                ></pace-core-text-input>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div class="mb-3 row">
                                        <label
                                            class="col-3 col-form-label"
                                            for="txtCity"
                                            translate="MATERIAL_ORDER_CITY_LABEL"
                                        ></label>
                                        <div class="col-9">
                                            <pace-core-text-input
                                                id="txtCity"
                                                [parentForm]="materialOrderFormChildren"
                                                name="txtCity"
                                                [(model)]="model.address.city"
                                                (valueChange)="onCityChange()"
                                                [ariaLabel]="'MATERIAL_ORDER_CITY_LABEL' | translate"
                                            ></pace-core-text-input>
                                        </div>
                                    </div>
                                    <div class="mb-3 row" *ngIf="model.address.statesOfUSA">
                                        <label
                                            class="col-3 col-form-label"
                                            for="txtState"
                                            translate="MATERIAL_ORDER_STATE_LABEL"
                                        ></label>
                                        <div class="col-9">
                                            <pace-core-dropdown
                                                class="col-12 col-lg-5"
                                                id="txtState"
                                                name="txtState"
                                                [parentForm]="materialOrderFormChildren"
                                                [(model)]="model.address.statesOfUSA"
                                            ></pace-core-dropdown>
                                        </div>
                                    </div>
                                    <div class="mb-3 row">
                                        <label
                                            class="col-3 col-form-label mb-3 mb-sm-0"
                                            for="txtPostcode"
                                            translate="MATERIAL_ORDER_ZIP_LABEL"
                                        ></label>
                                        <div class="col-9 col-sm-3 pe-lg-0">
                                            <pace-core-text-input
                                                id="txtPostcode"
                                                [parentForm]="materialOrderFormChildren"
                                                name="txtPostcode"
                                                [(model)]="model.address.postalCode"
                                                [ariaLabel]="'MATERIAL_ORDER_ZIP_LABEL' | translate"
                                            ></pace-core-text-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-4 row" [ngClass]="{ 'dop-read-only': isTextInfoReadonly }">
                                <label
                                    class="col-3 col-form-label"
                                    for="textInfo"
                                    translate="MATERIAL_ORDER_CREATE_TABLE_LABEL_TEXT_INFO"
                                ></label>
                                <div class="col-9">
                                    <pace-core-text-input
                                        id="textInfo"
                                        name="textInfo"
                                        [parentForm]="materialOrderFormChildren"
                                        [(model)]="model.textInfo"
                                        [ariaLabel]="'MATERIAL_ORDER_CREATE_TABLE_LABEL_TEXT_INFO' | translate"
                                    ></pace-core-text-input>
                                </div>
                            </div>
                            <div class="mb-4 row" *ngIf="model.isPaidDelivery">
                                <label
                                    class="col-3 col-form-label"
                                    for="customer-approver"
                                    translate="MATERIAL_ORDER_CREATE_TABLE_LABEL_CUSTOMER_APPROVER"
                                ></label>
                                <div class="col-9">
                                    <pace-core-text-input
                                        id="customer-approver"
                                        name="customer-approver"
                                        [parentForm]="materialOrderFormChildren"
                                        [(model)]="model.customerApprover"
                                        [ariaLabel]="'MATERIAL_ORDER_CREATE_TABLE_LABEL_CUSTOMER_APPROVER' | translate"
                                    ></pace-core-text-input>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6" [ngClass]="{ 'dop-read-only': model.isDopAddress }">
                            <label
                                *ngIf="this.model.isCustomerAddress"
                                class="col-form-label d-lg-none d-block text-start"
                            >
                                {{ this.model.subAddressMaxCharLabel }}
                            </label>
                            <div class="box-outlined" [ngClass]="{ border: this.model.isCustomerAddress }">
                                <div class="mb-3 row">
                                    <label
                                        class="col-3 col-form-label"
                                        for="txtDepartment"
                                        translate="MATERIAL_ORDER_DEPARTMENT_LABEL"
                                    ></label>
                                    <div class="col-9">
                                        <pace-core-text-input
                                            id="txtDepartment"
                                            [parentForm]="materialOrderFormChildren"
                                            name="txtDepartment"
                                            [(model)]="model.address.department"
                                            (valueChange)="onSubAddressChange()"
                                            [ariaLabel]="'MATERIAL_ORDER_DEPARTMENT_LABEL' | translate"
                                        ></pace-core-text-input>
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <ng-container *ngIf="displayFloor">
                                        <label
                                            class="col-3 col-form-label"
                                            for="txtFloor"
                                            translate="MATERIAL_ORDER_FLOOR_LABEL"
                                        ></label>
                                        <div class="col-9">
                                            <pace-core-text-input
                                                id="txtFloor"
                                                [parentForm]="materialOrderFormChildren"
                                                name="txtFloor"
                                                [(model)]="model.address.floor"
                                                (valueChange)="onSubAddressChange()"
                                                [ariaLabel]="'MATERIAL_ORDER_FLOOR_LABEL' | translate"
                                            ></pace-core-text-input>
                                        </div>
                                    </ng-container>
                                </div>
                                <div class="mb-3 row">
                                    <ng-container *ngIf="displayRoom">
                                        <label
                                            class="col-3 col-form-label"
                                            for="txtRoom"
                                            translate="MATERIAL_ORDER_ROOM_LABEL"
                                        ></label>
                                        <div class="col-9">
                                            <pace-core-text-input
                                                id="txtRoom"
                                                [parentForm]="materialOrderFormChildren"
                                                name="txtRoom"
                                                [(model)]="model.address.room"
                                                (valueChange)="onSubAddressChange()"
                                                [ariaLabel]="'MATERIAL_ORDER_ROOM_LABEL' | translate"
                                            ></pace-core-text-input>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>

                            <label class="col-form-label" *ngIf="this.model.isCustomerAddress">
                                {{ this.model.contactMaxCharLabel }}
                            </label>
                            <div class="box-outlined" [ngClass]="{ border: this.model.isCustomerAddress }">
                                <div class="mb-3 row">
                                    <label
                                        class="col-3 col-form-label"
                                        for="txtPhone"
                                        translate="MATERIAL_ORDER_PHONE_LABEL"
                                    ></label>
                                    <div class="col-9">
                                        <pace-core-text-input
                                            id="txtPhone"
                                            [parentForm]="materialOrderFormChildren"
                                            name="txtPhone"
                                            [(model)]="model.address.phone"
                                            (valueChange)="onContactChange()"
                                            [ariaLabel]="'MATERIAL_ORDER_PHONE_LABEL' | translate"
                                        >
                                        </pace-core-text-input>
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label
                                        class="col-3 col-form-label"
                                        for="txtContact"
                                        translate="MATERIAL_ORDER_CONTACT_LABEL"
                                    ></label>
                                    <div class="col-9">
                                        <pace-core-text-input
                                            id="txtContact"
                                            [parentForm]="materialOrderFormChildren"
                                            name="txtContact"
                                            [(model)]="model.address.contactPerson"
                                            (valueChange)="onContactChange()"
                                            [ariaLabel]="'MATERIAL_ORDER_CONTACT_LABEL' | translate"
                                        >
                                        </pace-core-text-input>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3 row">
                                <ng-container *ngIf="csmlPhoneNumber.length > 0">
                                    <label
                                        class="col-3 col-form-label"
                                        translate="MATERIAL_ORDER_CSML_PHONE_LABEL"
                                    ></label>
                                    <div class="col-9">
                                        <span class="form-control-plaintext pl-0">{{ csmlPhoneNumber }}</span>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <label
                    class="col-12 col-lg-2 col-form-label text-start text-lg-end"
                    *ngIf="displayMaterialLabel"
                    translate="MATERIAL_ORDER_CREATE_TABLE_LABEL"
                ></label>
                <div class="col">
                    <div class="table-header fw-bold">
                        <div class="row align-items-center">
                            <div
                                class="col-4 offset-2 col-lg-3 offset-lg-1"
                                translate="MATERIAL_ORDER_CREATE_TABLE_LABEL_MATNO"
                            ></div>
                            <div
                                class="d-none d-lg-block col-lg-4"
                                translate="MATERIAL_ORDER_CREATE_TABLE_LABEL_INFO"
                            ></div>
                            <div class="col-4 col-lg-3">
                                <div translate="MATERIAL_ORDER_CREATE_TABLE_LABEL_REQUESTED"></div>
                                <div translate="MATERIAL_ORDER_CREATE_TABLE_LABEL_UNIT"></div>
                            </div>
                        </div>
                    </div>
                    <div class="table-row py-2" *ngFor="let material of model.partSet.value; index as $index">
                        <pace-material-order-row-details
                            [parentForm]="materialOrderFormChildren"
                            [material]="material"
                            [displayOptions]="rowDisplayOptions"
                            (deleteMaterial)="deleteMaterial($index)"
                        ></pace-material-order-row-details>
                    </div>
                    <hr />
                    <div class="row my-3 justify-content-center justify-content-lg-start">
                        <div class="col-2">
                            <button
                                class="d-none d-lg-block btn btn-primary"
                                type="button"
                                translate="MATERIAL_ORDER_CREATE_TABLE_LABEL_ADD"
                                (click)="addMaterials()"
                            ></button>
                            <button
                                type="button"
                                (click)="addMaterials()"
                                class="d-lg-none btn btn-primary add-entry-round-btn d-flex align-items-center justify-content-center rounded-circle"
                                [attr.aria-label]="'MATERIAL_ORDER_CREATE_TABLE_LABEL_ADD' | translate"
                            >
                                <fa-icon [icon]="faPlus"></fa-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <ng-container *ngIf="!isLoading">
        <div class="me-auto" *ngIf="sparePartsCatalogLink" paceCoreLink>
            <a
                class="btn btn-primary pace-link"
                href="{{ sparePartsCatalogLink }}"
                target="_blank"
                translate="SPARE_PARTS_CATALOG_LINK_LABEL"
            ></a>
        </div>
        <button
            class="btn btn-primary"
            type="button"
            [disabled]="materialOrderForm.invalid"
            translate="MATERIAL_ORDER_CREATE_SEND_LABEL_ORDER"
            (click)="createMaterialOrder()"
        ></button>
    </ng-container>
    <progressbar type="default" [value]="100" *ngIf="isLoading">
        {{ 'MATERIAL_ORDER_CREATE_LOADING_MESSAGE' | translate }}</progressbar
    >
</div>
